export default __webpack_public_path__ + "static/media/sol.ca1168c9.webp";